import ActualNewsSlider from "./actual-news-slider";

$(function () {
    new ActualNewsSlider('.b-actual-news-desktop');
    new ActualNewsSlider('.b-actual-news-mobile');
});
